import { html } from 'lit-element'
import { ShellElement } from '../../common/shell-element'
import { t } from '../../directives/translate'
import scheduleSettingsStyles from './schedule-settings.styles.scss'

export class GoToScheduleSettings extends ShellElement {
  static readonly tagName = 'goto-schedule-settings'

  static get styles() {
    return scheduleSettingsStyles
  }

  render() {
    return html` <chameleon-typography class="settings-header" tag="h1" variant="heading-large">
      ${t('Schedule')}
    </chameleon-typography>`
  }
}

declare global {
  interface HTMLElementTagNameMap {
    readonly [GoToScheduleSettings.tagName]: GoToScheduleSettings
  }
}
